import { restDelete, restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import { PartnerAccountCandidateDto, PartnerDto, PartnerPayoutsDto } from "./restModels";
import {
    CreatePartnerPayoutRequestDto,
    CreatePartnerRequestDto,
    PartnerPayoutsListParams,
    UpdatePartnerAccountRequestDto,
    UpdatePartnerRequestDto,
} from "./restRequests";

export const getPartners = () => restGet<PartnerDto[]>("/partners");

export const getPartner = (id: number) => restGet<PartnerDto>(`/partners/${id}`);

export const getPartnerAccountCandidates = (query: string) =>
    restGet<PartnerAccountCandidateDto[]>("/partners/account-candidates", { query });

export const createPartner = (body: CreatePartnerRequestDto) =>
    restPost<PartnerDto>("/partners", body);

export const updatePartner = (id: number, body: UpdatePartnerRequestDto) =>
    restPut<PartnerDto>(`/partners/${id}`, body);

export const updatePartnerAccount = (id: number, body: UpdatePartnerAccountRequestDto) =>
    restPut<PartnerDto>(`/partners/${id}/account`, body);

export const deletePartner = (id: number) => restDelete<null>(`/partners/${id}`);

export const getPartnerPayouts = (params: PartnerPayoutsListParams) =>
    restGet<PartnerPayoutsDto>("/partner-payouts", {
        from: params.from,
        to: params.to,
        partnerId: params.partnerId || undefined,
    });

export const createPartnerPayout = (body: CreatePartnerPayoutRequestDto) =>
    restPost<null>("/partner-payouts", body);

export const deletePartnerPayout = (id: number) => restDelete<null>(`/partner-payouts/${id}`);
